import Type from '../type';

/**
 * The server marks the extensions it has put on a page or into a fragment as loaded with an inert
 * `<script type="extension/registered">{"name": "namespace", ...}</script>` block instead of an inline
 * call per extension. This module is the one place that knows the format.
 */
export const REGISTERED_EXTENSIONS_TYPE = 'extension/registered';

/**
 * Reads the body of one block into a name-to-namespace map. A malformed block yields nothing. A namespace
 * is kept as written, the empty one of a style-only extension included, the way `registerExtension` keeps
 * it; anything but a string falls back to `window`, as a missing namespace does there.
 */
export function parseRegisteredExtensions(body: string): Record<string, string>
{
	let namespaces: unknown = null;
	try
	{
		namespaces = JSON.parse(body);
	}
	catch
	{
		return {};
	}

	if (!Type.isPlainObject(namespaces))
	{
		return {};
	}

	return Object.fromEntries(
		Object.entries(namespaces).map(([name, namespace]) => [name, Type.isString(namespace) ? namespace : 'window']),
	);
}
